module.exports = __webpack_public_path__ + "media/images/about/b1@2x-ef3d9762f163bf920769a309bab50aa8.png";